import { MAX_AGE_RESTRICTION, MIN_AGE_RESTRICTION } from '../constants/registrationConstants';
import {
	AMERICAN_INDIAN,
	ASIAN_INDIAN,
	AFRICAN_AMERICAN,
	NATIVE_HAWAIIAN_PACIFIC_ISLANDER,
	CAUCASIAN_WHITE,
	OTHER,
	NOT_AVAILABLE
} from '../constants/ethnicityCodes';

export const isNumber = (value) => {
	return !isNaN(parseInt(value));
};

export const isWholeNumber = (value) => {
	return isNumber(value) && Number(value) % 1 === 0;
};

export const initCap = (str) => {
	if (!str) {
		return "";
	}

	let wordArray = str.split(" ");
	for (let i = 0; i < wordArray.length; i++) {
		let word = wordArray[i];
		wordArray[i] = word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
	}

	return wordArray.join(" ");
};

export const secondsToMinutes = (seconds = 0) => {
	return seconds / 60;
};

export const randomString = (stringLength) => {
	// http://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript

	// var randomString = Math.random().toString(16).substring(2,length + 2);

	var possible = 'abcdef0123456789'; // 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	var randomString = Array.apply(null, new Array(stringLength)).map(function () {
		return possible[Math.floor(Math.random() * possible.length)];
	}).join('');

	return randomString;
};

export const randomInt = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive 
};

export const sleep = (millis) => {
	return new Promise(resolve => setTimeout(resolve, millis));
};

export const escapeRegExp = (str) => {
	return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
};

export const replaceAll = (str, find, replace) => {
	return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
};

export const isValidAge = (age) => {
	return isWholeNumber(age) && Number(age) <= MAX_AGE_RESTRICTION && Number(age) >= MIN_AGE_RESTRICTION;
};

export const formatGender = (gender) => {
	const femaleIdentifiers = ["f", "female"];
	const maleIdentifiers = ["m", "male"];

	if (!gender) {
		return '';
	} else if (femaleIdentifiers.indexOf(gender.toLowerCase()) !== -1) {
		return "f";
	} else if (maleIdentifiers.indexOf(gender.toLowerCase()) !== -1) {
		return "m";
	}

	return '';
};

export const returnEthnicityRecode = (user) => {
	/*
		Hispanic - If Select Hispanic/Latino
		Black/AA - If Select African-American and Does not Select Hispanic/Latino
		Asian/Other - If Select Asian or Native American or Other and Does not Select Hispanic/Latino or AA
		White - Only selects White (Caucasian)
	*/

	if (user.ethnicity_hispanic) {
		return 'Hispanic';
	}

	if (user.ethnicity_race
		&& user.ethnicity_race.includes(AFRICAN_AMERICAN)
		&& !user.ethnicity_hispanic
	) {
		return 'Black/AA';
	}

	if (user.ethnicity_race
		&& (user.ethnicity_race.includes(ASIAN_INDIAN)
			|| user.ethnicity_race.includes(AMERICAN_INDIAN)
			|| user.ethnicity_race.includes(NATIVE_HAWAIIAN_PACIFIC_ISLANDER)
			|| user.ethnicity_race.includes(OTHER)
			|| user.ethnicity_race.includes(NOT_AVAILABLE))
		&& !user.ethnicity_race.includes(AFRICAN_AMERICAN)
		&& !user.ethnicity_hispanic
	) {
		return 'Asian/Other';
	}

	if (user.ethnicity_race
		&& user.ethnicity_race.includes(CAUCASIAN_WHITE)
		&& !user.ethnicity_race.includes(AMERICAN_INDIAN)
		&& !user.ethnicity_race.includes(AFRICAN_AMERICAN)
		&& !user.ethnicity_race.includes(ASIAN_INDIAN)
		&& !user.ethnicity_race.includes(NATIVE_HAWAIIAN_PACIFIC_ISLANDER)
		&& !user.ethnicity_race.includes(OTHER)
		&& !user.ethnicity_hispanic
	) {
		return 'White';
	}
};


// SVOD Helpers
export const returnTimeInSVOD = (svodStartTime, excludedTime) => {
	return svodStartTime ? (Date.now() - svodStartTime - excludedTime) / 1000 : 0;
};

export const isCurrentSVODEnvironmentPage = (location, route) => {
	return location && location.pathname && location.pathname === route;
};

export const isAppleTVGuidedTargetPrompt = (group) => {
	return group && group.svod_env && group.svod_env.guided_experience && group.svod_env.guided_experience.included_appletv_page;
};

export const isTargetAssetShowPagePrompt = (group) => {
	return group && group.svod_env && group.svod_env.guided_experience && group.svod_env.guided_experience.show_page_targets;
};

export const isSVODTargetAsset = (asset, targetAssets) => {
	if (!asset || !targetAssets || !targetAssets.length) return false;
	const filteredTargetAssets = targetAssets.filter(targetAsset => targetAsset._id === asset._id || targetAsset.id === asset._id);
	return !!filteredTargetAssets.length;
};

export const returnSelectedRowFromAsset = (asset, videoRows) => {
	for (let row_id in videoRows) {
		const row = videoRows[row_id];
		if (row[asset._id.valueOf()]) {
			return row_id;
		}
	}

	return null;
};

export const returnTargetAssetInfo = (targetAssetIndex, targetAssets, videos) => {
	let targetAsset, targetAssetRow;

	if (targetAssets) {
		let rowKeys = Object.keys(videos);

		rowKeys.forEach((rowKey) => {
			let assets = videos[rowKey];
			if (assets.hasOwnProperty(targetAssets[targetAssetIndex].id || targetAssets[targetAssetIndex]._id)) {
				targetAsset = assets[targetAssets[targetAssetIndex].id] || assets[targetAssets[targetAssetIndex]._id];
				targetAssetRow = rowKey;
			}
		});
	}

	return { targetAsset, targetAssetRow };
};

export const returnBrandingInformation = (selectedAsset = {}, rowInformation = []) => {
	if (selectedAsset.curated_asset) return { branding: selectedAsset.branding, hero_image: selectedAsset.hero_image };

	for (let i = 0; i < rowInformation.length; i++) {
		const row = rowInformation[i];
		if (row.curator_row
			&& row.assets
			&& row.assets.length
		) {
			for (let j = 0; j < row.assets.length; j++) {
				const asset = row.assets[j];
				if (asset._id === selectedAsset._id) {
					return { branding: row.branding, hero_image: row.hero_image };
				}
			}
		}
	}
	return null;
};

export const isValidJSON = (string) => {
	try {
		JSON.parse(string);
		return true;
	} catch (e) {
		return false;
	}
};

export const returnAnswerAndPathIdsFromSurvey = (panel, responses) => {
	const answerIds = [];
	const pathIds = [];
	const responsesMap = {};
	responses.forEach((response) => { responsesMap[response.qid] = response; });

	if (panel && panel.questions && panel.questions.length) {
		panel.questions.forEach((question) => {
			if (responsesMap[question.qid]) {
				const userResponse = responsesMap[question.qid];

				if (question.answers && question.answers.length) {
					question.answers.forEach((answer) => {
						if (userResponse.aid && userResponse.aid.includes(answer.aid)) {
							answerIds.push(answer.aid);

							if (answer.path) {
								pathIds.push(answer.path);
							}
						}

					});
				}
			}
		});
	}

	return { answerIds, pathIds };
};


// WEBPACK FOOTER //
// ./src/functions/utils.js